/**
 * American Vek: search query normalization.
 * Catalog titles carry the CA number glued to "CA" (e.g. "... | CA16460"), and Shopify search matches whole
 * tokens, so "16460" or "CA 16460" found nothing. A query that is only a CA number (3 to 6 digits, with or
 * without "CA", "C.A.", "CA:", "CA-") becomes "CA16460 OR 16460": it finds the CA and still finds model
 * numbers such as "2020". Used by assets/predictive-search.js (native, one-line edit) and on submit of any
 * search form; the field keeps what the shopper typed.
 */
const CA_QUERY = /^\s*(?:c\.?\s*a\.?\s*(?:n[ºo°.]?\s*)?[:#-]?\s*)?(\d{3,6})\s*$/i;

function normalize(term) {
  if (typeof term !== 'string') return term;
  const match = term.match(CA_QUERY);
  return match ? `CA${match[1]} OR ${match[1]}` : term;
}

// The script can be included more than once (header and mobile search); register once.
if (!window.AvSearch?.normalize) {
window.AvSearch = Object.assign(window.AvSearch || {}, { normalize });

// Full search submits (header modal, search page): send the normalized query.
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || !form.action.includes('/search')) return;
    const normalized = normalize(input.value);
    if (normalized === input.value) return;
    event.preventDefault();
    const url = new URL(form.action, location.origin);
    new FormData(form).forEach((value, key) => {
      if (key !== 'q' && typeof value === 'string') url.searchParams.append(key, value);
    });
    url.searchParams.set('q', normalized);
    window.location.href = url.toString();
  },
  true
);
}
